import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { HelpdeskService } from '../helpdesk.service';
import { HelpdeskReport } from '../helpdesk.model';
import { faFilter, faRotateRight, faSortAmountDownAlt, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbTooltip, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem, NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { NgIf, NgTemplateOutlet, NgFor, NgClass, DatePipe } from '@angular/common';

@Component({
    selector: 'app-report-list',
    templateUrl: './report-list.component.html',
    styleUrls: ['./report-list.component.css'],
    imports: [NgIf, NgbTooltip, FaIconComponent, NgTemplateOutlet, NgFor, NgClass, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem, NgbCollapse, DatePipe]
})
export class ReportListComponent implements OnInit, OnChanges {
  @Input() reportList: HelpdeskReport[];
  @Input() isLoading: boolean = false;
  @Output() selectReport = new EventEmitter();
  @Output() refreshBugReport = new EventEmitter();

  
  reportListFiltered: HelpdeskReport[] = []
  selectedId: string = null;
  sortBy = "createdAt"
  sortDirection: string = 'DESC';
  limit: number = null;
  selectedFilters: any[] =[];
  columnFilterValues =  new Map<any, any>([
    ["status", [
      {name: "In Review", value: "OPEN"},
      {name: "More Info Needed", value: "REQUEST INFO"},
      {name: "In Progress", value: "IN PROGRESS"},
      {name: "Follow Up", value: "FOLLOW UP"},
      {name: "Completed", value: "CLOSE"},
    ]],
  ]);

  activeFilters = new Map();
  activeFilterCount: number = 0;
  
  faFilter = faFilter;
  faSortAmountDownAlt = faSortAmountDownAlt;
  faRotateRight = faRotateRight;
  faSortDown = faSortDown;
  faSortUp = faSortUp;

  statuses: any[] = [
    {name: "In Review", value: "OPEN"},
    {name: "In Review", value: "CONSIDERING"},
    {name: "More Info Needed", value: "REQUEST INFO"},
    {name: "In Progress", value: "IN PROGRESS"},
    {name: "Follow Up", value: "FOLLOW UP"},
    {name: "Completed", value: "CLOSE"},
  ]

  constructor(
    private helpdeskService: HelpdeskService
  ) { }

  ngOnInit(): void {
    if(this.reportList.length > 0){
      this.reportListFiltered = [...this.reportList];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes && changes.reportList) {
      if(changes.reportList.currentValue) {
        this.reportListFiltered = [...this.reportList];
      }
    }
  }

  setSelectedReport(selectedId: string) {
    if (this.reportList && this.reportList.length != 0) {
      const filteredReport = this.reportList.filter(report => report.id == selectedId);
      this.selectedId = selectedId;
      this.selectReport.emit(filteredReport[0])
    }
  }

  capitalizeFirstLetter(string) {
    let small = string.toLowerCase();
    return small[0].toUpperCase() + small.slice(1);
  }

  getDistinctColumnValues(column: string): void {
    let tempArray = [];
    let statuses = [...new Set(this.reportList.map(item => item[column]))];

    statuses.forEach((item) => {
      tempArray.push({
        name: this.renameStatuses(item),
        value: item
      })
    })

    this.columnFilterValues.set(column, tempArray);
  }

  renameStatuses(value: any): string{
    return this.statuses.find(o => o.value.toLowerCase() === value.toLowerCase()).name;
  }

  addRemoveFilter(column: string, value: string): void {

    const index = this.selectedFilters.findIndex((o) => o.value === value);
    if(index < 0){
      this.selectedFilters.push({column: column, value: value});
    } else {
      this.selectedFilters.splice(index, 1);
    }
    this.filterArray();
  }

  filterArray(){
    let myArrayFiltered:any[] = [];
    if(this.selectedFilters.length > 0){
      myArrayFiltered = this.reportList.filter((el) => {
        return this.selectedFilters.some((filter) => {
          return el.status == filter.value;
        });
      });
    } else {
      myArrayFiltered = this.reportList;
    }
    

    this.reportListFiltered = myArrayFiltered;
  }

  setSort(column: string): void {
    if (column != this.sortBy) this.sortDirection = 'ASC';
    if (column == this.sortBy) this.sortDirection = (this.sortDirection == 'ASC') ? 'DESC' : 'ASC';
    this.sortBy = column;

    this.sortReportList();
  }

  sortReportList(){
    let sortedArray:any[] = []

    if(this.sortDirection === 'ASC'){
      sortedArray = this.reportList.sort((d1, d2) => new Date(d1.createdAt).getTime() - new Date(d2.createdAt).getTime());
    } else {
      sortedArray = this.reportList.sort((d1, d2) => new Date(d2.createdAt).getTime() - new Date(d1.createdAt).getTime());
    }
    
    this.reportListFiltered = sortedArray;
  }

  resetActiveFilters(): void {
    this.selectedFilters = [];
    this.filterArray();
    this.sortReportList();
  }

  supportTypeConversion(type){
    return type == '1' ? 'Bug Report' : type == '2' ? 'Support Ticket' : 'Feature';
  }

  checkIfSelected(value: any): boolean{
    let a = this.selectedFilters.some( filter => filter['value'] == value );
    return a;
  }

  refreshBugReports(){
    this.selectedFilters = [];
    this.sortDirection = 'DESC';
    this.refreshBugReport.emit(this);
  }
}
